/*!
=========================================================
* Painel Toca da Onça — Aniversariantes & Datas
=========================================================
* Carmen coleta as datas COM consentimento (LGPD) e felicita com mensagem bíblica.
*/
import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Badge, Button } from "reactstrap";

const MODELOS = [
  "Feliz aniversário, [nome]! 🎉 'O Senhor te abençoe e te guarde' (Números 6:24). Que esse novo ano seja de muita saúde e alegria. Com carinho, Toca da Onça 🐆",
  "[nome], hoje é seu dia! 🥳 'Eu sei os planos que tenho para vós, planos de paz' (Jeremias 29:11). Deus te abençoe grandemente!",
  "Parabéns, [nome]! Que Deus renove suas forças e te dê vida longa (Salmo 91:16). Um abraço da família Toca da Onça 💛",
];

function Aniversarios() {
  const [dados, setDados] = React.useState(null);
  React.useEffect(() => {
    fetch("/clientes_datas.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then(setDados)
      .catch(() => {});
  }, []);
  const lista = (dados && dados.aniversariantes) || [];

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>Aniversariantes &amp; datas</h3>
          <p className="text-muted">
            A Carmen felicita cada cliente na data especial com uma mensagem bíblica. Cria lealdade
            de verdade.
          </p>
          {dados && dados.modo === "exemplo" && (
            <div style={{ background: "rgba(255,176,32,.12)", border: "1px solid rgba(255,176,32,.4)", borderRadius: 10, padding: "10px 14px", marginBottom: 8 }}>
              <span className="text-warning">
                <i className="tim-icons icon-alert-circle-exc" /> Exemplos — a Carmen ainda está coletando as datas reais (com consentimento, conversando com cada cliente).
              </span>
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col lg="6" md="12">
          <Card className="card-tasks">
            <CardHeader>
              <h6 className="title d-inline">Felicitar hoje / em breve</h6>
              <p className="card-category d-inline"> {lista.length} pessoas</p>
            </CardHeader>
            <CardBody>
              <div className="table-full-width table-responsive">
                <table style={{ width: "100%" }}>
                  <tbody>
                    {lista.map((a, i) => (
                      <tr key={i}>
                        <td style={{ width: 44 }}>
                          <div style={{ width: 40, height: 40, borderRadius: "50%", background: "#e14eca", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 600 }}>
                            {a.nome.charAt(0)}
                          </div>
                        </td>
                        <td>
                          <p className="title text-white" style={{ margin: 0 }}>{a.nome}</p>
                          <p className="text-muted" style={{ margin: 0 }}>
                            {a.tipo} · {a.dia} <Badge color="primary" pill>{a.uf}</Badge>
                          </p>
                        </td>
                        <td className="text-right">
                          <Button color="success" size="sm"><i className="tim-icons icon-send" /> Felicitar</Button>
                        </td>
                      </tr>
                    ))}
                    {lista.length === 0 && (
                      <tr><td className="text-muted">Nenhuma data coletada ainda. A Carmen começa a perguntar nas conversas.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col lg="6" md="12">
          <Card>
            <CardHeader><CardTitle tag="h4">Mensagens bíblicas prontas</CardTitle></CardHeader>
            <CardBody>
              {MODELOS.map((m, i) => (
                <div key={i} style={{ background: "rgba(29,205,159,.06)", borderLeft: "3px solid #1dcd9f", borderRadius: "0 8px 8px 0", padding: "10px 14px", marginBottom: 10 }}>
                  <p className="text-white" style={{ margin: 0, fontSize: 14 }}>{m}</p>
                </div>
              ))}
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xs="12">
          <Card>
            <CardHeader><CardTitle tag="h4">O que a ficha do cliente vai guardar</CardTitle></CardHeader>
            <CardBody>
              <Row>
                {[
                  { i: "icon-gift-2", t: "Aniversário", d: "dia/mês pra felicitar" },
                  { i: "icon-single-02", t: "Família", d: "datas de esposa, filhos" },
                  { i: "icon-email-85", t: "E-mail & redes", d: "contato consentido" },
                  { i: "icon-square-pin", t: "Cidade atual", d: "detecta mudança" },
                  { i: "icon-bag-16", t: "Última compra", d: "o que comprou" },
                  { i: "icon-ruler-pencil", t: "Tamanho", d: "numeração preferida" },
                  { i: "icon-money-coins", t: "Ticket médio", d: "quanto gasta" },
                  { i: "icon-trophy", t: "Cliente VIP", d: "as melhores" },
                ].map((c, i) => (
                  <Col lg="3" md="6" key={i}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                      <i className={"tim-icons " + c.i + " text-info"} style={{ fontSize: 22 }} />
                      <div>
                        <p className="text-white" style={{ margin: 0, fontWeight: 500 }}>{c.t}</p>
                        <p className="text-muted" style={{ margin: 0, fontSize: 12 }}>{c.d}</p>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Aniversarios;
